import { aiTips, type AiTip } from "@/mocks/managerWorkspace";

export default function AiTipWidget() {
  const visibleTips = aiTips.slice(0, 2);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-1.5 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-robot-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">AI-подсказка</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D2D2D]">{aiTips.length}</span>
      </div>
      <div className="flex-1 overflow-auto p-2 space-y-1.5">
        {visibleTips.map((tip: AiTip, i: number) => (
          <div key={i} className="p-1.5 rounded border border-[#D5CA8A]/40 hover:bg-[#FDF2B5]/20 transition-colors">
            <div className="flex items-start gap-1.5 mb-1">
              <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 ${tip.priorityColor}`}>
                <i className={`${tip.icon} text-[10px]`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className={`inline-block px-1 py-0.5 rounded text-[7px] font-medium mb-0.5 ${tip.priorityColor}`}>
                  {tip.priority}
                </span>
                <p className="text-[9px] text-[#2D2D2D] leading-relaxed line-clamp-3">{tip.text}</p>
              </div>
            </div>
            <button className="w-full py-1 bg-[#E8DB6C] text-[#2D2D2D] text-[9px] font-semibold rounded hover:bg-[#D5CA8A] transition-colors cursor-pointer whitespace-nowrap">
              {tip.action}
            </button>
          </div>
        ))}
      </div>
      <div className="px-3 py-1 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все подсказки
        </button>
      </div>
    </div>
  );
}